import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Typography,
} from '@mui/material';
import {
  SubscriptionDataQuery,
  SubscriptionPlanType,
} from '../../generated/graphql';

interface PaywallConfirmationDialogProps {
  open: boolean;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
  subscriptionData?: SubscriptionDataQuery;
  loading?: boolean;
}

export const PaywallConfirmationDialog: React.FC<
  PaywallConfirmationDialogProps
> = ({ open, onConfirm, onCancel, subscriptionData, loading }) => {
  const renderContent = () => {
    if (loading) {
      return <CircularProgress />;
    }

    if (subscriptionData) {
      return (
        <>
          Current subscription plan:{' '}
          {subscriptionData.subscriptionData?.subscriptionPlanType}
        </>
      );
    }
    return <Typography>No subscription data available</Typography>;
  };

  return (
    <Dialog open={open}>
      <Box p={2}>
        {renderContent()}
        <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
          <Button color="inherit" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={
              subscriptionData?.subscriptionData?.subscriptionPlanType ===
              SubscriptionPlanType.AwaitingPayment
            }
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
